import * as actionTypes from './actionTypes'
import { LOGOUT_USER } from '../user/actionTypes'

const initialState = {
    topCustomerList: { topCustomers: [], total: 0, pageSize: 0, topCustomersCompare: [], totalCompare: 0, pageSizeCompare: 0, error: null, loading: false },
    storeVisitorList: { storeVisitors: [], total: 0, error: null, loading: false },
    sellsByDayList: { sellsByDay: [], total: 0, error: null, loading: false },
    sellsByHourList: { sellsByHour: [], total: 0, error: null, loading: false },
    sellsByMonthList: { sellsByMonth: [], total: 0, error: null, loading: false },
    sellsTopEmployeesList: { sellsTopEmployees: [], total: 0, error: null, loading: false },
    sellsTopCategoriesList: { sellsTopCategories: [], total: 0, error: null, loading: false },
    averageTicketList: { averageTicket: [], total: 0, error: null, loading: false },
    newClientsList: { newClients: [], total: 0, error: null, loading: false },
    franchiseReportList: { franchiseReport: [], total: 0, pageSize: 0, error: null, loading: false }
}

export default (state = initialState, action) => {
    switch (action.type) {

        case actionTypes.FETCH_AVERAGE_TICKET:
            return {
                ...state,
                averageTicketList: {
                    ...state.averageTicket,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_AVERAGE_TICKET_SUCCESS:
            return {
                ...state,
                averageTicketList: {
                    averageTicket: action.payload.averageTicket,
                    total: action.payload.total,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_AVERAGE_TICKET_FAILURE:
            return {
                ...state,
                averageTicketList: {
                    averageTicket: [],
                    total: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_AVERAGE_TICKET:
            return { ...state, averageTicketList: initialState.averageTicketList }


        case actionTypes.FETCH_NEW_CLIENTS:
            return {
                ...state,
                newClientsList: {
                    ...state.newClients,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_NEW_CLIENTS_SUCCESS:
            return {
                ...state,
                newClientsList: {
                    newClients: action.payload.newClients,
                    total: action.payload.total,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_NEW_CLIENTS_FAILURE:
            return {
                ...state,
                averageTicketList: {
                    newClientsList: [],
                    total: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_NEW_CLIENTS:
            return { ...state, newClientsList: initialState.newClientsList }


        case actionTypes.FETCH_TOP_CUSTOMERS:
            return {
                ...state,
                topCustomerList: {
                    ...state.topCustomerList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_TOP_CUSTOMERS_SUCCESS:
            return {
                ...state,
                topCustomerList: {
                    topCustomers: action.payload.topCustomers,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false,
                    topCustomersCompare: action.payload.topCustomersCompare,
                    totalCompare: action.payload.totalCompare,
                    pageSizeCompare: action.payload.pageSizeCompare,
                }
            }

        case actionTypes.FETCH_TOP_CUSTOMERS_FAILURE:
            return {
                ...state,
                topCustomerList: {
                    topCustomers: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_TOP_CUSTOMERS:
            return { ...state, topCustomerList: initialState.topCustomerList }

        case actionTypes.FETCH_STORE_VISITORS:
            return {
                ...state,
                storeVisitorList: {
                    ...state.storeVisitorList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_STORE_VISITORS_SUCCESS:
            return {
                ...state,
                storeVisitorList: {
                    storeVisitors: action.payload.storeVisitors,
                    total: action.payload.total,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_STORE_VISITORS_FAILURE:
            return {
                ...state,
                storeVisitorList: {
                    storeVisitors: [],
                    total: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_STORE_VISITORS:
            return { ...state, storeVisitorList: initialState.storeVisitorList }

        case actionTypes.FETCH_SELLS_BY_DAY:
            return {
                ...state,
                sellsByDayList: {
                    ...state.sellsByDayList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_SELLS_BY_DAY_SUCCESS:
            return {
                ...state,
                sellsByDayList: {
                    sellsByDay: action.payload.sellsByDay,
                    total: action.payload.total,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_SELLS_BY_DAY_FAILURE:
            return {
                ...state,
                sellsByDayList: {
                    sellsByDay: [],
                    total: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_SELLS_BY_DAY:
            return { ...state, sellsByDayList: initialState.sellsByDayList }


        case actionTypes.FETCH_SELLS_BY_HOUR:
            return {
                ...state,
                sellsByHourList: {
                    ...state.sellsByHourList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_SELLS_BY_HOUR_SUCCESS:
            return {
                ...state,
                sellsByHourList: {
                    sellsByHour: action.payload.sellsByHour,
                    total: action.payload.total,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_SELLS_BY_HOUR_FAILURE:
            return {
                ...state,
                sellsByHourList: {
                    sellsByHour: [],
                    total: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_SELLS_BY_HOUR:
            return { ...state, sellsByHourList: initialState.sellsByHourList }


        case actionTypes.FETCH_SELLS_BY_MONTH:
            return {
                ...state,
                sellsByMonthList: {
                    ...state.sellsByMonthList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_SELLS_BY_MONTH_SUCCESS:
            return {
                ...state,
                sellsByMonthList: {
                    sellsByMonth: action.payload.sellsByMonth,
                    total: action.payload.total,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_SELLS_BY_MONTH_FAILURE:
            return {
                ...state,
                sellsByMonthList: {
                    sellsByMonth: [],
                    total: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_SELLS_BY_MONTH:
            return { ...state, sellsByMonthList: initialState.sellsByMonthList }

        case actionTypes.FETCH_SELLS_TOP_EMPLOYEES:
            return {
                ...state,
                sellsTopEmployeesList: {
                    ...state.sellsTopEmployeesList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_SELLS_TOP_EMPLOYEES_SUCCESS:
            return {
                ...state,
                sellsTopEmployeesList: {
                    sellsTopEmployees: action.payload.sellsTopEmployees,
                    total: action.payload.total,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_SELLS_TOP_EMPLOYEES_FAILURE:
            return {
                ...state,
                sellsTopEmployeesList: {
                    sellsTopEmployees: [],
                    total: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_SELLS_TOP_EMPLOYEES:
            return { ...state, sellsTopEmployeesList: initialState.sellsTopEmployeesList }


        case actionTypes.FETCH_SELLS_TOP_CATEGORIES:
            return {
                ...state,
                sellsTopCategoriesList: {
                    ...state.sellsTopCategoriesList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_SELLS_TOP_CATEGORIES_SUCCESS:
            return {
                ...state,
                sellsTopCategoriesList: {
                    sellsTopCategories: action.payload.sellsTopCategories,
                    total: action.payload.total,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_SELLS_TOP_CATEGORIES_FAILURE:
            return {
                ...state,
                sellsTopCategoriesList: {
                    sellsTopCategories: [],
                    total: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_SELLS_TOP_CATEGORIES:
            return { ...state, sellsTopCategoriesList: initialState.sellsTopCategoriesList }

        case actionTypes.FETCH_FRANCHISE_REPORT:
            return {
                ...state,
                franchiseReportList: {
                    franchiseReport: [],
                    total: 0,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_FRANCHISE_REPORT_SUCCESS:
            return {
                ...state,
                franchiseReportList: {
                    franchiseReport: action.payload.data,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_FRANCHISE_REPORT_FAILURE:
            return {
                ...state,
                franchiseReportList: {
                    franchiseReport: [],
                    total: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_FRANCHISE_REPORT:
            return {
                ...state, franchiseReportList: initialState.franchiseReportList
            }

        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/dashboard/reducer.js